import get from './get';
import softCheck from './softCheck';

const creditAPI = (caseEndpoint: string) => ({
  get: () => get(`${caseEndpoint}/credit`),
  softCheck: () => softCheck(`${caseEndpoint}/credit`),
});

export default creditAPI;
